package com.eladfinish.bible.contest.screens.pastQuizzes

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.ui.components.WebViewBridge

/** No WebView here: the exam opens in the browser, which shares by itself. */
@Composable
actual fun rememberExamShareBridge(): WebViewBridge? = null
